import { render, staticRenderFns } from "./TablePager.vue?vue&type=template&id=a63e22c0&"
import script from "./TablePager.vue?vue&type=script&lang=js&"
export * from "./TablePager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports